import {post} from '../utils/request'

export default {
    getAll: function (query, paginate) {
        return post("/admin/report/list", {...query, ...paginate});
    },
    deleteById: function (id) {
        return post("/admin/report/del", {id});
    }
}
